import { Button, Container, Stack, Text, Title } from '@mantine/core';
import { Link } from '@tanstack/react-router';

import { Seo } from '@shared/ui/seo';

export const NotFoundPage = () => (
  <Container size="sm" py="var(--space-16)">
    <Seo title="Страница не найдена" description="Такой страницы нет." robots="noindex,nofollow" />
    <Stack align="flex-start" gap="lg">
      <Text fw={700} c="var(--color-brand)">
        Ошибка 404
      </Text>
      <Title order={1}>Страница не найдена</Title>
      <Text c="dimmed">Проверьте адрес или вернитесь к сегодняшним квизам.</Text>
      <Button component={Link} to="/">
        На главную
      </Button>
    </Stack>
  </Container>
);
